import React from "react";

interface SectionHeaderProps {
  badge?: string;
  title: string;
  subtitle?: string;
  center?: boolean;
  dark?: boolean;
}

export default function SectionHeader({
  badge,
  title,
  subtitle,
  center = false,
  dark = false,
}: SectionHeaderProps) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-7 md:mb-12`}>
      {badge && (
        <span
          className={`inline-flex items-center gap-2 py-1.5 px-4 rounded-full text-[12px] font-label-md uppercase tracking-[0.12em] mb-5 font-bold border ${
            dark
              ? "border-white/15 bg-white/[0.06] text-primary-fixed-dim"
              : "border-primary/20 bg-primary/10 text-primary dark:text-orange-400"
          }`}
        >
          <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-primary-fixed-dim" : "bg-primary"}`} />
          {badge}
        </span>
      )}
      <h2
        className={`font-headline-lg-mobile text-headline-lg-mobile md:text-headline-lg md:font-headline-lg font-semibold leading-[1.12] tracking-[-0.02em] ${
          dark ? "text-inverse-on-surface" : "text-on-surface"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`font-body-lg text-body-lg mt-5 leading-relaxed ${
            dark ? "text-inverse-on-surface/80" : "text-on-surface-variant"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
